import React, { useContext, useState } from 'react';
import { UserContext } from '../../contexts/User';
import { NotificationContext } from '../../contexts/Notification';
import './impersonationBanner.css';

function ImpersonationBanner() {
  const { user, impersonatedBy, stopImpersonation } = useContext(UserContext);
  const { displayNotification } = useContext(NotificationContext);
  const [stopping, setStopping] = useState(false);

  if (!impersonatedBy) return null;

  const handleStop = async () => {
    setStopping(true);
    const result = await stopImpersonation();
    setStopping(false);
    displayNotification({
      message: result.success
        ? 'You have returned to your Primary owner account.'
        : result.error || 'There was an issue ending impersonation. Please try again.',
      severity: result.success ? 'success' : 'error',
    });
  };

  return (
    <div className="impersonation-banner" role="status">
      <span>
        Impersonating
        {' '}
        {`${user?.firstName || ''} ${user?.lastName || ''}`.trim() || user?.email}
      </span>
      <button type="button" onClick={handleStop} disabled={stopping}>
        {stopping ? 'Returning…' : 'Stop'}
      </button>
    </div>
  );
}

export default ImpersonationBanner;
